module.exports = __webpack_public_path__ + "media/images/logo-7f8ae5c4aa904e42c24b20fa86b25a5f.svg";